import { useState, useEffect } from 'react';
import { useScrollSpy } from '../hooks/useInView';

const NAV_ITEMS = [
  { label: 'Home',       id: 'hero'       },
  { label: 'About',      id: 'about'      },
  { label: 'Stack',      id: 'stack'      },
  { label: 'Experience', id: 'experience' },
  { label: 'Projects',   id: 'projects'   },
  { label: 'Skills',     id: 'skills'     },
  { label: 'Contact',    id: 'contact'    },
];

const scrollTo = (id) => {
  if (id === 'hero') { window.scrollTo({ top: 0, behavior: 'smooth' }); return; }
  document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
};

export default function Nav() {
  const [scrolled, setScrolled]   = useState(false);
  const [menuOpen, setMenuOpen]   = useState(false);
  const activeId = useScrollSpy(NAV_ITEMS.map(n => n.id), 80);

  useEffect(() => {
    const h = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', h, { passive: true });
    return () => window.removeEventListener('scroll', h);
  }, []);

  return (
    <nav className={`sticky top-0 z-50 flex items-center gap-2.5 px-4 sm:px-8 h-14
                    transition-all duration-300
                    ${scrolled ? 'bg-[rgba(8,12,20,.95)] border-b border-bord backdrop-blur-xl' : 'bg-transparent border-b border-transparent'}`}>
      {/* Logo */}
      <a href="#hero" onClick={e => { e.preventDefault(); scrollTo('hero'); }}
         className="flex items-center gap-2 no-underline flex-shrink-0">
        <div className="w-7 h-7 rounded-lg bg-gradient-to-br from-aws to-aws2 flex items-center justify-center font-mono font-black text-xs text-black">
          A
        </div>
        <span className="font-mono text-xs text-aws hidden sm:block">
          akrosh<span className="text-tx3">.</span>dev
        </span>
      </a>

      {/* Desktop links */}
      <div className="hidden md:flex gap-0.5 flex-1 overflow-x-auto py-0.5">
        {NAV_ITEMS.map(item => {
          const isActive = activeId === item.id;
          return (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className={`font-mono text-[10px] px-3 py-1.5 rounded-md border transition-all duration-150 whitespace-nowrap cursor-pointer
                         ${isActive
                           ? 'text-aws bg-aws/[.13] border-aws/25'
                           : 'text-tx3 bg-transparent border-transparent hover:text-tx'}`}
            >
              {item.label}
            </button>
          );
        })}
      </div>

      {/* Status pill */}
      <div className="hidden sm:flex items-center gap-1.5 bg-grn/10 border border-grn/28 rounded-full px-3 py-1.5 flex-shrink-0">
        <div className="w-1.5 h-1.5 rounded-full bg-grn animate-pulse-dot" />
        <span className="font-mono text-[10px] text-grn whitespace-nowrap">Available</span>
      </div>

      {/* Mobile hamburger */}
      <button
        onClick={() => setMenuOpen(!menuOpen)}
        className="md:hidden ml-auto flex flex-col gap-1 p-2 cursor-pointer bg-transparent border-none"
      >
        <span className={`block w-5 h-0.5 bg-tx transition-all duration-200 ${menuOpen ? 'rotate-45 translate-y-1.5' : ''}`} />
        <span className={`block w-5 h-0.5 bg-tx transition-all duration-200 ${menuOpen ? 'opacity-0' : ''}`} />
        <span className={`block w-5 h-0.5 bg-tx transition-all duration-200 ${menuOpen ? '-rotate-45 -translate-y-1.5' : ''}`} />
      </button>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="absolute top-14 left-0 right-0 bg-bg2 border-b border-bord z-50 flex flex-col py-2 md:hidden">
          {NAV_ITEMS.map(item => (
            <button
              key={item.id}
              onClick={() => { scrollTo(item.id); setMenuOpen(false); }}
              className={`font-mono text-xs px-5 py-3 text-left cursor-pointer bg-transparent border-none
                         ${activeId === item.id ? 'text-aws' : 'text-tx2 hover:text-tx'}`}
            >
              {item.label}
            </button>
          ))}
        </div>
      )}
    </nav>
  );
}
